import * as Constants from "_core/configs/Constants";

// シーン定数
export const SCENE_ACCOUNT       = 'account';
export const SCENE_ADMIN         = 'admin';
export const SCENE_ERROR         = 'error';

// パーツ定数、汎用
export const PARTS_TOP = 'top';

// パーツ定数、アカウント
export const PARTS_ACCOUNT_SIGNUP                    = 'signup';
export const PARTS_ACCOUNT_LOGIN                     = 'login';
export const PARTS_ACCOUNT_EDIT                      = 'edit';
export const PARTS_ACCOUNT_RESET_PASSWORD            = 'resetpassword';
export const PARTS_ACCOUNT_CHANGE_PASSWORD           = 'changepassword';
export const PARTS_ACCOUNT_COMPLETE_CHANGE_PASSWORD  = 'completechangepassword';
export const PARTS_ACCOUNT_COMPLETE_SEND_MAIL        = 'completesendmail';

// パーツ定数、管理画面
export const PARTS_ADMIN_USEREDIT                = 'useredit';
export const PARTS_ADMIN_USER_CHATLOG            = 'userchatlog';
export const PARTS_ADMIN_USER_CHATREPORT         = 'userchatreport';
export const PARTS_ADMIN_USER_PROFILE_EDIT       = 'userprofileedit';
export const PARTS_ADMIN_USER_LEARNING_EDIT      = 'userprolearningedit';
export const PARTS_ADMIN_USER_MOVIE_UPLOAD       = 'usermovieupload';
export const PARTS_ADMIN_USER_RAG_STRUCTURE      = 'userragstructure';
export const PARTS_ADMIN_USER_RAG_UPLOAD         = 'userragupload';
export const PARTS_ADMIN_USER_RAG_EVALUATE       = 'userragevaluate';
export const PARTS_ADMIN_USER_RAG_PLAYGROUND     = 'userragplayground';
export const PARTS_ADMIN_CHARACTER_CREATE        = 'charactercreate';
export const PARTS_ADMIN_WELCOME_MSG_EDIT        = 'welcomemsgedit';
export const PARTS_ADMIN_HR_NEWS_EDIT            = 'hrnewsedit';

// パーツ定数、インフォ
export const PARTS_DETAIL = 'detail';
export const PARTS_POLICY = 'policy';
export const PARTS_PRIVACY_POLICY = 'privacy_policy';

// パーツ定数、エラー
export const PARTS_ERROR_403 = '403';
export const PARTS_ERROR_404 = '404';

// demo
export const SCENE_DEMO_WEB_SOCKET = 'd-websocket';

export const ADMIN_CHECK_SCENE_LIST= [
    "admin",
];

export const PAGES = {
    ACCOUNT_CHANGE_PASSWORD                 : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ACCOUNT + "/" + PARTS_ACCOUNT_CHANGE_PASSWORD,
    ACCOUNT_COMPLETE_CHANGE_PASSWORD        : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ACCOUNT + "/" + PARTS_ACCOUNT_COMPLETE_CHANGE_PASSWORD,
    ACCOUNT_COMPLETE_SEND_MAIL              : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ACCOUNT + "/" + PARTS_ACCOUNT_COMPLETE_SEND_MAIL,
    ACCOUNT_LOGIN                           : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ACCOUNT + "/" + PARTS_ACCOUNT_LOGIN,
    ACCOUNT_RESET_PASSWORD                  : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ACCOUNT + "/" + PARTS_ACCOUNT_RESET_PASSWORD,
    ACCOUNT_SIGNUP                          : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ACCOUNT + "/" + PARTS_ACCOUNT_SIGNUP,
    ACCOUNT_TOP                             : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ACCOUNT + "/" + PARTS_TOP,
    ADMIN_USER_EDIT                         : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USEREDIT,
    PARTS_ADMIN_USER_CHATLOG                : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_CHATLOG,
    PARTS_ADMIN_USER_PROFILE_EDIT           : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_PROFILE_EDIT,
    PARTS_ADMIN_USER_LEARNING_EDIT          : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_LEARNING_EDIT,
    PARTS_ADMIN_USER_RAG_STRUCTURE          : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_RAG_STRUCTURE,
    PARTS_ADMIN_USER_MOVIE_UPLOAD           : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_MOVIE_UPLOAD,
    PARTS_ADMIN_USER_RAG_UPLOAD             : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_RAG_UPLOAD,
    PARTS_ADMIN_USER_RAG_EVALUATE           : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_RAG_EVALUATE,
    PARTS_ADMIN_USER_RAG_PLAYGROUND         : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_RAG_PLAYGROUND,
    PARTS_ADMIN_USER_CHATREPORT             : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_USER_CHATREPORT,
    PARTS_ADMIN_CHARACTER_CREATE            : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_CHARACTER_CREATE,
    PARTS_ADMIN_WELCOME_MSG_EDIT            : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_WELCOME_MSG_EDIT,
    PARTS_ADMIN_HR_NEWS_EDIT                : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ADMIN   + "/" + PARTS_ADMIN_HR_NEWS_EDIT,
    ERROR_403                               : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ERROR   + "/" + PARTS_ERROR_403,
    ERROR_404                               : Constants.REACT_APP_BASE_PATH + "/" + SCENE_ERROR   + "/" + PARTS_ERROR_404,
};

